import React from "react";

const MarkerIcon = (props) => {
  return (
    <svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 4.5C1.77842e-08 3.30653 0.474106 2.16193 1.31802 1.31802C2.16193 0.474106 3.30653 0 4.5 0C5.69347 0 6.83807 0.474106 7.68198 1.31802C8.52589 2.16193 9 3.30653 9 4.5C9 7.5 4.5 12 4.5 12C4.5 12 0 7.5 0 4.5ZM2.625 4.5C2.625 4.99728 2.82254 5.47419 3.17417 5.82583C3.52581 6.17746 4.00272 6.375 4.5 6.375C4.99728 6.375 5.47419 6.17746 5.82583 5.82583C6.17746 5.47419 6.375 4.99728 6.375 4.5C6.375 4.00272 6.17746 3.52581 5.82583 3.17417C5.47419 2.82254 4.99728 2.625 4.5 2.625C4.00272 2.625 3.52581 2.82254 3.17417 3.17417C2.82254 3.52581 2.625 4.00272 2.625 4.5Z"
        fill="#2D5DEC"
      />
    </svg>
  );
};

export default MarkerIcon;
